import {MailRounded, PeopleRounded} from "@mui/icons-material";

const ProfileMenus = [
    {
        href: "/app/profile",
        title: "My Profile",
        subtitle: "Account Settings",
        icon: PeopleRounded,
    },
    // {
    //     href: "/apps/email",
    //     title: "My Inbox",
    //     subtitle: "Messages & Emails",
    //     icon: MailRounded,
    // }
];

export default ProfileMenus;